<template src="./Home.html"></template>
<style scoped src="./Home.scss" lang="scss"></style>
<script>
import Hero from "@/components/Hero/";
import Grid from "@/components/Grid/";

// import json from '@/components/../public/data/videos.json'

export default {
  name: "Home",
  props: ['idVideo'],
  data() {
    return {
      msg: "XX"
    };
  },
  components: {
    "app-hero": Hero,
    "app-grid": Grid
  },
  mounted: function(){
  },
  // beforeRouteEnter (to, from, next) {
  //     console.log("home::beforeRouteEnter");
  //     console.log(to, from);
  //     next();
  //     // getPost(to.params.id, (err, post) => {
  //     //   next(vm => vm.setData(err, post))
  //     // })
  // }//,
};
</script>
